export default {
  sections: {
    business_info: 'Informazioni aziendali',
    bank_info: 'Dati bancari',
  },
  form: {
    company_name: {
      label: 'Nome del ristorante',
      placeholder: 'Nome del ristorante',
    },
    business_name: {
      label: 'Ragione sociale',
      placeholder: 'Ragione sociale',
    },
    owner_full_name: {
      label: 'Nome del titolare',
      placeholder: 'Nome del titolare',
    },
    business_address: {
      label: 'Indirizzo aziendale',
      placeholder: 'Indirizzo aziendale',
    },
    business_zip_code: {
      label: 'CAP aziendale',
      placeholder: 'CAP aziendale',
    },
    business_city: {
      label: "Città dell'azienda",
      placeholder: "Città dell'azienda",
    },
    business_country: {
      label: "Paese dell'azienda",
      options: {
        DE: 'Germania',
        GB: 'Regno Unito',
        US: 'Stati Uniti',
      },
    },
    company_phone_number: {
      label: 'Numero di telefono del ristorante',
      placeholder: 'Numero di telefono del ristorante',
    },
    contact_person_full_name: {
      label: 'Nome del referente',
      placeholder: 'Nome del referente',
    },
    contact_person_phone_number: {
      label: 'Numero di telefono del referente',
      placeholder: 'Numero di telefono del referente',
    },
    contact_person_email: {
      label: 'Email del referente',
      placeholder: 'Email del referente',
    },
    business_bank_account_holder_name: {
      label: 'Intestatario del conto bancario',
      placeholder: 'Intestatario del conto bancario',
    },
    business_bank_account_number: {
      label: 'Numero di conto bancario',
      placeholder: 'DE01101234567891234567',
    },
    business_bank_routing_number: {
      label: 'Codice ABI/CAB',
      placeholder: '110000000',
    },
    business_tax_id: {
      label: 'Partita IVA aziendale',
      placeholder: 'Partita IVA aziendale',
    },
  },
};
